
import { defineComponent } from "vue";
import { IPreschoolDimensionsModel } from "@/interfaces/modules";
import PreschoolDimensionsService from "@/api/Preschool/PreschoolDimensionsService";
import router from "@/router";

export default defineComponent({
  name: "PreschoolDimensionsContent",
  data() {
    return {
      form: {
        dialog: false,
        record: {} as IPreschoolDimensionsModel,
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "Name", label: "Nombre", sortable: true },
          { key: "Code", label: "Código", sortable: true },
          { key: "Description", label: "Descripción", sortable: true },
          { key: "ImageUrl", label: "Imagen", sortable: false },
          { key: "Status", label: "Activo", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as IPreschoolDimensionsModel[],
        rowsPerPage: 10,
      } as any,
    };
  },

  computed: {
    filteredItems(): any {
      return this.table.filters.search
        ? this.table.records.filter(
          (item: any) =>
            item.Name.toLowerCase().includes(this.table.filters.search.toLowerCase()) ||
            item.Code.toLowerCase().includes(this.table.filters.search.toLowerCase())
        )
        : this.table.records;
    },
    rows(): any {
      return this.table.records?.length || 0;
    },
  },

  async mounted() {
    await this.load();
  },

  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await PreschoolDimensionsService.GetPreschoolDimensions();
      this.table.loading = false;
    },
    async open(Id: number) {
      router.push(`/preschool/preschool-dimension-edit/${Id}`);
    },
  },
});
